// extracted by mini-css-extract-plugin
export default {"header":"header__iytLDT","headerAssignSpeaker":"headerAssignSpeaker__KYTqJJ","speakerName":"speakerName__cfMVGG","nameText":"nameText__hicTKJ"};